// addon-incompatibility.js
document.addEventListener('DOMContentLoaded', () => {
  const checkboxes = Array.from(document.querySelectorAll('.add-on-products'));

  // Define groups: each array = set of mutually exclusive add-ons
  // Values are variant IDs
  const groups = [
    // WhisperKOOL exterior grill and condenser duct kit
    ["50983442546962", "50983442579730", "50983443595538", "50983443628306"] 

  ];

  function recompute() {
    // enable everything first
    checkboxes.forEach(cb => cb.disabled = false);

    groups.forEach(group => {
      const checked = checkboxes.filter(cb => group.includes(cb.value) && cb.checked);
      if (checked.length > 0) {
        const active = checked[0];
        group.forEach(val => {
          const target = checkboxes.find(cb => cb.value === val);
          if (target && target !== active) {
            target.checked = false;
            target.disabled = true;
          }
        });
      }
    });
  }

  checkboxes.forEach(cb => cb.addEventListener('change', recompute));
  recompute();
});
